import { NBSP } from '../constants/symbols';
import { TRecommendation } from '../types/recommendation';
import { priceToString } from './formatters/price';

export const formatOfferPrice = (offer: TRecommendation) => {
  const isOfferDailyCategory = offer.category.includes('daily');

  const formattedPrice = priceToString(offer.price);

  return isOfferDailyCategory ? `от${NBSP}${formattedPrice}` : formattedPrice;
};
